import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { Box, Container, Typography } from '@mui/material'
import KeyIcon from '@mui/icons-material/Key'

import useProtectedPage from 'src/hooks/useProtectedPage'

import { AlertContext } from 'src/context/AlertContext'
import { ROUTES } from 'src/routes/Router'
import { goToApiKeys } from 'src/routes/coordinator'
import { AlertComponent } from 'src/components/Alert/AlertComponent'
import { ApiKeyForm } from './components/Form/ApiKeyForm'
import { createApiKey } from 'src/service/apiKeysService'
import { generateExpirationDate } from 'src/util/generate-expiration-date'
import { ModalApiKeyContext } from 'src/context/ModalCreatedApiKeyContext'
import { ApiKeyModel } from 'src/models/api-key-model'

export const CreateApiKey = () => {
  useProtectedPage()
  const { t } = useTranslation()
  const history = useNavigate()
  const { createCRUDAlert } = useContext(AlertContext)
  const { openModalApiKey } = useContext(ModalApiKeyContext)

  const onSubmit = async (data) => {
    const validData = {
      name: data.name,
      companyId: data?.companyId?.id,
      version: 'v1',
      scope: 'public',
      expiresAt: generateExpirationDate(data.expiresAt),
    }
    const res = await createApiKey(validData)
    if (res) {
      createCRUDAlert(ROUTES.APIKEYS, validData?.name, 'created')
      openModalApiKey(ROUTES.APIKEYS, (res as ApiKeyModel)?.apiKey)
      goToApiKeys(history)
    }
  }

  return (
    <Container sx={{ mt: '96px' }}>
      <AlertComponent />
      <Box
        component="div"
        sx={{
          color: '#FF5E1E',
          display: 'flex',
          gap: '10px',
          alignItems: 'center',
          justifyContent: 'flex-start',
          mb: '24px',
        }}
      >
        <KeyIcon sx={{ width: '30.55px', height: '28px' }} />
        <Typography
          variant="h6"
          sx={{
            fontWeight: '500',
            fontSize: '20px',
            lineHeight: '160%',
            letterSpacing: ' 0.15px',
            color: ' #FF5E1E',
            marginTop: '-1px',
          }}
        >
          {t('apikey.title')}
        </Typography>
      </Box>

      <ApiKeyForm onSubmit={onSubmit} />
    </Container>
  )
}
